import { createFileRoute, redirect } from "@tanstack/react-router";

import { authUserSchema } from "@/modules/auth/schemes";
import { TypesListPage } from "@/modules/types/pages/TypesList.page";

export const Route = createFileRoute("/__authed/m/admin/types")({
	beforeLoad({ context }) {
		const parsedUser = authUserSchema.safeParse("user" in context ? context.user : undefined);

		if (!parsedUser.success || parsedUser.data.role.slug !== "admin") {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: TypesListPage,
});
